import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisBigNumberChartResponseDto,
  IAnalysisBigNumberChartResultVo,
} from '../types';

import {
  isNonEmptyWireArray,
  normalizeTableDataList,
  pickChartDisplayMeta,
} from './common';

export function transformBigNumberChartResponseDtoToVo(
  dto: IAnalysisBigNumberChartResponseDto,
): IAnalysisBigNumberChartResultVo {
  const {
    big_number_charts: bigNumberChartsWire,
    table_data: tableDataWire,
  } = dto;
  const isNoData = !isNonEmptyWireArray(bigNumberChartsWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.BigNumber,
    isNoData,
    ...(isNoData
      ? {}
      : {
          bigNumberChart: bigNumberChartsWire,
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
